(function () {
  const BADGE_LABEL = 'In Cart';

  function getCards() {
    const cards = new Set();
    document.querySelectorAll('product-form.card__add-to-cart').forEach((form) => {
      const card = form.closest('.card-wrapper');
      if (card) cards.add(card);
    });
    return Array.from(cards);
  }

  function getAddForm(card) {
    return card.querySelector('product-form.card__add-to-cart');
  }

  function getVariantId(card) {
    const input = getAddForm(card)?.querySelector('input[name="id"]');
    return input?.value || null;
  }

  function getBadgeEl(card) {
    return card.querySelector('.card-cart-badge');
  }

  function ensureBadgeEl(card) {
    let badge = getBadgeEl(card);
    if (badge) return badge;

    badge = document.createElement('span');
    badge.className = 'card-cart-badge badge';
    badge.setAttribute('aria-live', 'polite');
    badge.innerHTML = `
      <svg class="card-cart-badge__icon" width="12" height="12" viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <path d="M16.3125 5.625H3.6875C3.53371 5.62572 3.38545 5.68242 3.27042 5.78451C3.1554 5.88659 3.08149 6.02707 3.0625 6.17969L1.95313 16.1797C1.94326 16.2668 1.95184 16.355 1.9783 16.4386C2.00477 16.5222 2.04853 16.5993 2.10674 16.6649C2.16495 16.7305 2.2363 16.7831 2.31617 16.8193C2.39604 16.8555 2.48263 16.8745 2.57031 16.875H17.4297C17.5174 16.8745 17.604 16.8555 17.6838 16.8193C17.7637 16.7831 17.8351 16.7305 17.8933 16.6649C17.9515 16.5993 17.9952 16.5222 18.0217 16.4386C18.0482 16.355 18.0567 16.2668 18.0469 16.1797L16.9375 6.17969C16.9185 6.02707 16.8446 5.88659 16.7296 5.78451C16.6146 5.68242 16.4663 5.62572 16.3125 5.625Z" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M6.25 5C6.25 4.00544 6.64509 3.05161 7.34835 2.34835C8.05161 1.64509 9.00544 1.25 10 1.25C10.9946 1.25 11.9484 1.64509 12.6517 2.34835C13.3549 3.05161 13.75 4.00544 13.75 5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span class="card-cart-badge__text">${BADGE_LABEL}</span>
    `;

    const inner = card.querySelector('.card__inner');
    if (!inner) return null;
    inner.appendChild(badge);
    return badge;
  }

  function setCardInCart(card, quantity) {
    const badge = ensureBadgeEl(card);
    const textEl = badge?.querySelector('.card-cart-badge__text');

    if (quantity > 0) {
      card.classList.add('card-wrapper--in-cart');
      if (badge) badge.classList.add('is-visible');
      if (textEl) {
        textEl.textContent = quantity > 1 ? `${BADGE_LABEL} (${quantity})` : BADGE_LABEL;
      }
    } else {
      card.classList.remove('card-wrapper--in-cart');
      if (badge) badge.classList.remove('is-visible');
      if (textEl) textEl.textContent = BADGE_LABEL;
    }
  }

  function setVariantInCart(variantId, quantity) {
    if (!variantId) return;

    getCards().forEach((card) => {
      if (getVariantId(card) === String(variantId)) {
        setCardInCart(card, quantity);
      }
    });
  }

  function syncCardsFromCartState(cart) {
    if (!cart?.items) return;

    getCards().forEach((card) => {
      const variantId = getVariantId(card);
      if (!variantId) return;
      const item = cart.items.find((line) => String(line.variant_id) === String(variantId));
      setCardInCart(card, item ? item.quantity : 0);
    });
  }

  async function fetchCart() {
    const response = await fetch(`${window.routes?.cart_url || '/cart'}.js`);
    if (!response.ok) throw new Error('Failed to fetch cart');
    return response.json();
  }

  async function syncAllCards() {
    if (!getCards().length) return;

    try {
      const cart = await fetchCart();
      syncCardsFromCartState(cart);
    } catch (error) {
      console.error(error);
    }
  }

  function handleCartState(cart) {
    if (cart?.items) {
      syncCardsFromCartState(cart);
      return true;
    }
    return false;
  }

  function handleCartUpdate(event) {
    if (handleCartState(event?.cart)) return;
    syncAllCards();
  }

  function handleCartRefresh(event) {
    if (handleCartState(event.detail?.cart)) return;

    if (event.detail?.variantId != null) {
      setVariantInCart(event.detail.variantId, 1);
      return;
    }

    syncAllCards();
  }

  function handleRemoveClick(event) {
    const removeBtn = event.target.closest('cart-remove-button[data-variant-id]');
    if (!removeBtn) return;
    setVariantInCart(removeBtn.dataset.variantId, 0);
  }

  function handleQuantityInput(event) {
    const input = event.target.closest('.cart-item quantity-input input[name="updates[]"]');
    if (!input) return;

    const lineItem = input.closest('.cart-item, tr.cart-item');
    const removeBtn = lineItem?.querySelector('cart-remove-button[data-variant-id]');
    if (!removeBtn) return;

    const quantity = parseInt(input.value, 10);
    if (!Number.isFinite(quantity) || quantity > 0) return;
    setVariantInCart(removeBtn.dataset.variantId, 0);
  }

  function init() {
    syncAllCards();

    if (typeof subscribe === 'function') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, handleCartUpdate);
    }

    document.addEventListener('cart:refresh', handleCartRefresh);
    document.addEventListener('click', handleRemoveClick, true);
    document.addEventListener('change', handleQuantityInput, true);
    window.addEventListener('pageshow', syncAllCards);

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') syncAllCards();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
